import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Button, IconButton, Spinner, useColorModeValue, useToast } from "@chakra-ui/react";
import { MdOutlineMyLocation } from "react-icons/md";

import ReactGA from 'react-ga4';
import { CoffeeShopContext } from "../../context/CoffeeShopContext";

const FindNearMeButton = ({ iconOnly = false }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const { updateUserLocation, setGpsLocation } = useContext(CoffeeShopContext);
  const [loadingLocation, setLoadingLocation] = useState(false);

  const btnColor       = useColorModeValue("#6a4020",                "#c8a97e");
  const btnBorder      = useColorModeValue("rgba(139,62,18,0.28)",   "rgba(200,169,126,0.32)");
  const btnBg          = useColorModeValue("rgba(139,62,18,0.04)",   "rgba(200,169,126,0.05)");
  const btnHoverBg     = useColorModeValue("rgba(139,62,18,0.09)",   "rgba(200,169,126,0.11)");
  const btnHoverBorder = useColorModeValue("rgba(139,62,18,0.48)",   "rgba(200,169,126,0.52)");

  const handleFindNearMe = () => {
    ReactGA.event({ category: 'Button', action: 'Click', label: 'Find Near Me' });
    setLoadingLocation(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const coords = { latitude: position.coords.latitude, longitude: position.coords.longitude };
          setGpsLocation(coords);   // the blue dot — device position, nothing else sets this
          updateUserLocation(coords);
          setLoadingLocation(false);
          navigate("/explore");
        },
        (error) => {
          setLoadingLocation(false);
          toast({ title: "Location unavailable", description: "Search for a neighborhood or city instead, or allow location access in your browser.", status: "info", isClosable: true });
        }
      );
    } else {
      setLoadingLocation(false);
      toast({ title: "Search by neighborhood or city", description: "This browser doesn’t support location access.", status: "info", isClosable: true });
    }
  };

  if (iconOnly) return (
      <Box position="relative" flexShrink={0}>
        <IconButton
          onClick={handleFindNearMe}
          icon={loadingLocation ? <Spinner size="xs" /> : <MdOutlineMyLocation size="18px" />}
          isDisabled={loadingLocation}
          variant="outline"
          borderRadius="full"
          h={{ base: "40px", md: "48px" }}
          w={{ base: "40px", md: "48px" }}
          minW="unset"
          color={btnColor}
          borderColor={btnBorder}
          bg={btnBg}
          _hover={{ bg: btnHoverBg, borderColor: btnHoverBorder }}
          transition="background 0.18s ease, border-color 0.18s ease"
          aria-label="Find near me"
          title="Find near me"
        />
      </Box>
  );

  return (
    <Button
      onClick={handleFindNearMe}
      isLoading={loadingLocation}
      leftIcon={<MdOutlineMyLocation size="15px" />}
      variant="outline"
      borderRadius="20px"
      h={{ base: "40px", md: "48px" }}
      fontSize={{ base: "13px", md: "13px" }}
      fontFamily="body"
      letterSpacing="0.05em"
      fontWeight={500}
      color={btnColor}
      borderColor={btnBorder}
      bg={btnBg}
      _hover={{ bg: btnHoverBg, borderColor: btnHoverBorder }}
      transition="background 0.18s ease, border-color 0.18s ease"
    >
      Find near me
    </Button>
  );
};

export default FindNearMeButton;
